import * as React from 'react';

const DocPlaceholder = () => (
  <svg width="110" height="140" viewBox="0 0 110 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H74.2609C77.3791 0 80.3748 1.21375 82.6136 3.38418L106.353 26.3983C108.684 28.6585 110 31.767 110 35.0141V128C110 134.627 104.627 140 98 140H12C5.37258 140 0 134.627 0 128V12Z"
      fill="#E1E1EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.0026 0.598145C77.9469 0.782484 77.9165 0.981374 77.9165 1.19264L77.9165 28.8857C77.9165 29.9903 78.8119 30.8857 79.9165 30.8857H108.76C108.931 30.8857 109.093 30.866 109.246 30.8292C108.63 29.1714 107.648 27.6539 106.353 26.3982L82.6134 3.38403C81.2956 2.10645 79.7155 1.16034 78.0026 0.598145Z"
      fill="#F0F0F5"
    />
    <rect x="13" y="86" width="84" height="6" rx="3" fill="#F0F0F5" />
    <rect x="13" y="98" width="84" height="6" rx="3" fill="#F0F0F5" />
    <rect x="13" y="110" width="84" height="6" rx="3" fill="#F0F0F5" />
    <rect x="13" y="122" width="84" height="6" rx="3" fill="#F0F0F5" />
    <rect x="34" y="64" width="42" height="6" rx="3" fill="#F0F0F5" />
  </svg>
);

export default DocPlaceholder;
